import Image from "next/image";

// A bar with the logo only: no link, no menu, no banner.
export const StrippedNavbar = () => (
  <header className="flex justify-center items-center py-5 px-4 lg:px-6">
    <div className="relative w-[200px] h-[21.6px] lg:w-[240px] lg:h-[26px]">
      <Image
        src={"/images/logo/logo-default.svg"}
        layout="fill"
        alt="mobile club logo"
      />
    </div>
  </header>
);
